import { render, staticRenderFns } from "./ServiceHallCard.vue?vue&type=template&id=92188bf8"
import script from "./ServiceHallCard.vue?vue&type=script&lang=js"
export * from "./ServiceHallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports